<div class="product-cards-wrapper" [class.inclusi-mode]="isInclusi">
  <label class="field-label">
    {{ field.etichetta }}
    <span class="required" *ngIf="field.obbligatorio && !isInclusi">*</span>
  </label>

  <div class="loading-products" *ngIf="loading">
    <div class="spinner"></div>
    <span>Caricamento...</span>
  </div>

  <!-- Inclusi mode: compact list -->
  <div class="inclusi-list" *ngIf="!loading && isInclusi">
    <div class="inclusi-item" *ngFor="let card of cards">
      <span class="inclusi-name">{{ card.name }}</span>
      <span class="inclusi-price" *ngIf="showPrices">{{
        formatPrice(card.quotaTotale)
      }}</span>
    </div>
  </div>

  <!-- Selezione mode: clickable cards -->
  <div class="product-cards" *ngIf="!loading && !isInclusi">
    <div
      *ngFor="let card of cards"
      class="product-card"
      [class.selected]="isSelected(card.key)"
      (click)="toggleCard(card.key)"
    >
      <div class="card-content">
        <div class="card-name">{{ card.name }}</div>
        <div class="card-description" *ngIf="card.description">
          {{ card.description }}
        </div>
      </div>
      <ng-container *ngIf="showPrices && !card.isFreeOption">
        <div class="card-price">{{ formatPrice(card.quotaTotale) }}</div>
        <div class="card-acconto" *ngIf="card.amount < card.quotaTotale">
          Acconto: {{ formatPrice(card.amount) }}
        </div>
      </ng-container>
      <div class="card-price free" *ngIf="card.isFreeOption">Gratuito</div>
    </div>
  </div>

  <div class="error-loading" *ngIf="loadError">
    {{ loadError }}
  </div>
</div>
